<template>
    <div v-if="info" style="background-color: #fffbf7">
        <section class="banner">
            <img :src="info.banner" alt="">
        </section>
        <section class="main-container">
            <section class="sec-01">
                <section class="title-wrap">
                    <img class="title-img" src="../../assets/img/property/title_background.png" alt="">
                </section>
                <div class="bg-text">
                    <p>{{info.introduce}}</p>
                </div>
            </section>
            <section class="sec-02" v-if="info.topics">
                <img class="bg-decorate" src="../../assets/img/property/img_yinhao.png" alt="">
                <section class="title-wrap">
                    <img class="title-img" src="../../assets/img/property/title_forumtheme.png" alt="">
                    <img class="title-tip" src="../../assets/img/property/title_theme.png" alt="">
                </section>
                <div class="bg-text">
                    <p>{{info.topics[0].introduce}}</p>
                </div>
            </section>
            <section class="sec-03" v-if="info.setting_introduce&&info.setting_introduce.length>0">
                <div class="part part-1">
                    <img src="../../assets/img/property/banner_forumtopic.png" alt="">
                </div>
                <div v-for="(item,index) in info.setting_introduce" class="part part-other" :class="'part-'+Number(index+2)">
                    <h3>{{item.title}}</h3>
                    <p>{{item.summary}}</p>
                </div>
<!--                <div class="part part-other part-3">-->
<!--                    <h3>告别高杠杆 融资收紧之下的房企增长之路</h3>-->
<!--                    <p>-->
<!--                        政策收紧力度似乎让大多数房企措手不及，地产高杠杆的时代面临着终结，企业如何适应新的监管和融资环境?如何降负债的同时保增长？房地产行业如何真正向居住属性回归？2020年地产时代百强论坛将对这些问题进行重点探讨。</p>-->
<!--                </div>-->
<!--                <div class="part part-other part-4">-->
<!--                    <h3>重塑价值，服务让生活更美好</h3>-->
<!--                    <p>2020年地产时代百强论坛，将重点探讨房企“长期主义”战略下，物业管理要扮演怎样的角色？如何淘金物业万亿蓝海？物业管理如何讲好并购“生意经”？物业管理的智能化趋势等前沿问题。</p>-->
<!--                </div>-->
            </section>
            <section class="sec-04">
                <div class="sec-04-container">
                    <img class="title" src="../../assets/img/property/title_agenda.png" alt="">
                    <div class="time-div">
                        <i class="time-icon"></i>
                        <span>{{info.topics[0].date.replace(/-/g,".")}}</span>
                        <i class="line-icon"></i>
                        <i class="addr-icon"></i>
                        <span class="addr-text ellipsis" :title="info.topics[0].address">{{info.topics[0].address}}</span>
                    </div>
                    <div class="time-line" v-if="info.topics[0].flows">
                        <ul style="padding-right: 56px;border-right: 1px solid #E5ECFF">
                            <li v-for="(item,index) in info.topics[0].flows" v-if="index<3">
                                <span class="time-num">{{item.time}}</span>
                                <span>{{item.title}}</span>
                            </li>
                        </ul>
                        <ul style="padding-left: 56px;">
                            <li v-for="(item,index) in info.topics[0].flows" v-if="index>=3">
                                <span class="time-num">{{item.time}}</span>
                                <span>{{item.title}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="sec-05">
                <div class="sec-title">
                    <img src="../../assets/img/property/title_guests.png" alt="">
                </div>
                <div class="guests-list">
                    <ul>
                        <li v-for="item in info.topics[0].guests">
                            <div class="guests-wrap">
                                <img :src="item.avatar" alt="">
                            </div>
                            <i class="arrow-icon"></i>
                            <p class="guest-name">{{item.name_zh}}</p>
                            <p class="guest-tip">{{item.titles.join("，")}}</p>
                        </li>
                    </ul>
                </div>
            </section>
            <section class="sec-06">
                <img class="sec-06-title" src="../../assets/img/property/title_news.png" alt="">
                <div class="container-inner">
                    <div class="swiper-container">
                        <div v-if="info.information.banner && info.information.banner.length" class="swiper-box mt40 mb20">
                            <swiper style="width: 100%;height: 488px;" :options="swiperOption">
                                <swiper-slide class="swiper-slide" v-for="(item,index) in info.information.banner" :key="index">
                                    <div class="swiper-img-wrap"><img :src="item.banner" alt=""></div>
                                    <div class="swiper-item-text">
                                        <h3>{{ item.title }}</h3>
                                        <p>{{ item.summary }}</p>
                                    </div>
                                </swiper-slide>
                                <!-- 分页器 -->
                                <div class="swiper-pagination"  slot="pagination"></div>
                                <!-- 左右箭头 -->
                                <div @click.stop class="swiper-button-prev" slot="button-prev"></div>
                                <div @click.stop class="swiper-button-next" slot="button-next"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="relative-news" v-if="info.information.arts&&info.information.arts.length>0">
                        <h3>相关新闻</h3>
                        <ul class="news-list">
                            <li v-for="item in info.information.arts"  @click="onLink(item.link)">
                                <p>{{item.title}}</p>
                                <span class="time-icon-two">{{item.ago}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="review-news">
                        <section class="title-wrap">
                            <img class="title-img" src="../../assets/img/property/title_pastevents.png" alt="">
                        </section>
<!--                        <div class="flex-row">-->
                            <ul class="re-list">
                                <li v-for="item in info.retrospects" @click="onLink(item.link)">
                                    <h3>{{item.title}}</h3>
                                    <p>{{item.summary}}</p>
                                </li>
                            </ul>
                    </div>
                </div>
            </section>
            <section class="sec-07">
                <img src="../../assets/img/property/bg_organization.png" alt="">
            </section>
        </section>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                info: null,
                swiperOption:{
                    //显示分页
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    //设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    loop: false
                },
            }
        },
        methods:{
            getTopicsInfo() {
                const { forum_id = null } = this.$route.query
        
                this.$api.topics.getTopicsInfo({ forum_id }).then((res) => {
                    if (res.status === 'success') {
                        this.info = res.data;
                        document.title=this.info.title;
                    }
                })
            },
            onLink(link = null) {
                if (!link) {
                    return
                }
        
                window.open(link)
            },
        },
        created() {
            this.getTopicsInfo()
        }
    }
</script>
<style lang="scss" scoped>
    @font-face {
        font-family: DIN;
        src: url("../../assets/font/DIN-Bold.otf");
    }
    p,h1,h2,h3{
        padding:0;
        margin: 0;
    }
    ul{
        list-style: none;
        margin:0;
        padding:0;
    
    }
    img{
        max-width: unset;
        max-height: unset;
    }
    .banner{
        position: relative;
        z-index: 999;
        img{
            width: 100%;
        }
        
    }
    .main-container{
        width: 1200px;
        margin: -15px auto 0;
    }
    .sec-01{
        padding:64px 0 91px;
        background-color: #fff;
    }
    .title-wrap{
        text-align: center;
    }
    .title-img{
        height: 38px;
    }
    .bg-text{
        font-size: 16px;
        color: #333333;
        line-height: 28px;
        width: 987px;
        margin:29px auto 0;
        p{
            margin:0;
            white-space: pre-line;
            word-wrap:break-word;
        }
    }
    .sec-other{
        position: relative;
        top:-10px;
    }
    .sec-02{
        background: url("../../assets/img/property/bg_theme.png") no-repeat top left;
        background-size: 100% 100%;
        /*height: 341px;*/
        padding:40px;
        box-sizing: border-box;
        position: relative;
    }
    .title-tip{
        height: 44px;
        display: block;
        margin:39px auto 0;
    }
    .bg-decorate{
        width: 90px;
        position: absolute;
        top:-20px;
        left:86px;
    }
    .sec-03{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding:70px 100px 49px;
        background: #fff;
    }
    .part{
        width: 50%;
        margin-bottom: 30px;
        h3{
            font-size: 20px;
            font-weight: 600;
            color: #643101;
            margin:0;
            position: relative;
            width: 423px;
            line-height: 25px;
            &:before{
                content: "";
                display: inline-block;
                height: 19px;
                width: 33px;
                position: absolute;
                left:-50px;
                top:3px;
            }
        }
        p{
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            margin:16px 0;
            text-align: justify;
            width: 423px;
        }
        &.part-1 img{
            height: 129px;
        }
        &.part-other{
            padding-left:54px;
            box-sizing: border-box;
        }
        &.part-2 h3:before{
            background: url("../../assets/img/property/num_1.png") no-repeat;
            background-size: cover;
        
        }
        &.part-3 h3:before{
            background: url("../../assets/img/property/num_2.png") no-repeat;
            background-size: cover;
        
        }
        &.part-4 h3:before{
            background: url("../../assets/img/property/num_3.png") no-repeat;
            background-size: cover;
        
        }
    }
    .sec-04{
        background: url("../../assets/img/property/bg_agenda.png") no-repeat top left;
        background-size: 100% auto;
        height: 429px;
        position: relative;
        .sec-04-container{
            position: absolute;
            right:90px;
            top:170px;
            .title{
                height: 52px;
                margin-bottom: 37px;
                display: block;
            }
        }
        .time-div{
            background: url("../../assets/img/property/bg_time_1.png") no-repeat left top;
            background-size: 100% auto;
            width: 670px;
            font-size: 20px;
            font-family: DIN;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 30px;
            display: flex;
            align-items: center;
        }
        .time-icon{
            display: inline-block;
            width: 17px;
            height: 17px;
            background: url("../../assets/img/property/time.png") no-repeat;
            background-size: cover;
            margin:0 8px 0 20px;
        }
        .addr-icon{
            display: inline-block;
            width: 16px;
            height: 18px;
            background: url("../../assets/img/property/location.png") no-repeat;
            background-size: cover;
            margin:0 8px 0 20px;
        }
        .line-icon{
            display: inline-block;
            height: 12px;
            width: 1px;
            background: #FFFFFF;
            margin-left:20px;
        }
        .addr-text{
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            max-width: 400px;
            height: 30px;
            overflow: hidden;
        }
        .time-line{
            display: flex;
            justify-content: space-between;
            padding-top:30px;
            .time-num{
                font-family: DIN;
                font-style: italic;
                font-size: 16px;
                color: #333333;
                line-height: 16px;
                margin-right: 130px;
        
            }
            ul li:nth-child(-n+2){
                margin-bottom: 20px;
            }
        }
    }
    
    .sec-05{
        display: flex;
        justify-content: space-between;
        background: #fff;
        padding:92px 101px 36px 99px;
    }
    .sec-title{
        padding-right: 18px;
    }
    .sec-title img{
        height: 53px;
        width: 108px;
    }
    .guests-list ul{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .guests-list ul li{
        margin-left:114px;
        width:177px;
        overflow: hidden;
    }
    .guests-list ul li img{
        height: 188px;
        width: auto;
        
    }
    .guests-wrap{
        display: flex;
        height: 188px;
        width: 177px;
        justify-content: center;
        position: relative;
        overflow: hidden;
        border-radius: 6px 6px 0px 0px;
        
    }
    .guests-wrap:after{
        content: "";
        width: 100%;
        height: 11px;
        display: inline-block;
        background: url("../../assets/img/property/pic_mask.png") no-repeat;
        background-size: 100% auto;
        position: absolute;
        bottom: 0;
        left: 0;
    }
    .arrow-icon{
        display: inline-block;
        width: 15px;
        height: 13px;
        background: url("../../assets/img/property/icon_arrow.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 15px;
    }
    .guest-name{
        margin:20px 0 10px;
        font-size: 18px;
        font-weight: 600;
        color: #343434;
    }
    .guest-tip{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #343434;
        line-height: 14px;
        margin-bottom: 69px;
    }
    .sec-06{
        background: #fff;
    }
    .sec-06-title{
        width: 100%;
    }
    .container-inner{
        padding:26px 101px 105px 99px;
    }
    
    .relative-news h3{
        font-size: 16px;
        color: #343434;
        line-height: 24px;
        margin: 24px 0 18px;
        padding-left:14px;
        display:flex;
        align-items: center;
    }
    .relative-news h3:before{
        content: "";
        width: 4px;
        height: 14px;
        background: #9C6422;
        position: relative;
        left: -14px;
    }
    .news-list{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .news-list li{
        width:30%;
        padding-bottom: 15px;
    }
    .news-list li:nth-child(3n-1){
        margin:0 25px;
        padding:0 24px;
        border-left: 1px solid rgba(222, 222, 222, 1);
        border-right: 1px solid rgba(222, 222, 222, 1);
        width: 35%;
    }
    
    .news-list li p{
        padding:15px 0;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #444444;
        line-height: 24px;
        width: 300px;
    }
    .news-list li:nth-child(-n+3) p{
        padding:0 0 15px;
    }
    .news-list li:nth-last-child(-n+3){
        padding-bottom: 0;
    }
    
    .time-icon-two{
        font-size: 15px;
        color: #9A9A9A;
        display: inline-flex;
        align-items: center;
    }
    .time-icon-two:before{
        content: "";
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url("../../assets/img/property/icon_time.png") no-repeat;
        background-size: cover;
        margin-right: 8px;
    }
    .review-news .title-wrap{
        margin: 76px 0 30px;
    }
    /*.flex-row{*/
    /*    display: flex;*/
    /*    */
    /*}*/
    .re-list{
        display: flex;
        flex-wrap: wrap;
    }
    /*.re-list:nth-child(2){*/
    /*    margin:0 35px;*/
    /*}*/
    .re-list li{
        width: 30%;
        padding-top:20px;
        margin-right: 35px;
        text-align: justify;
        &:nth-child(-n+3){
            border-top:3px solid rgba(156, 100, 34, 1);
            padding-top:30px;
        }
        &:nth-child(3n){
            margin-right: 0;
        }
        h3{
            font-size: 14px;
            color: #444444;
            line-height: 24px;
        }
        p{
            font-size: 13px;
            color: #9A9A9A;
            line-height: 23px;
            
        }
    }
    .sec-07 img{
        width: 100%;
    }
    .swiper-item-text{
        width: 500px;
        position: absolute;
        bottom: 40px;
        left:60px;
    }
    .swiper-item-text h3{
        font-size: 18px;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 11px;
    }
    .swiper-item-text p{
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .swiper-img-wrap{
        width: 100%;
        height: 488px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: relative;
    
    }
    .swiper-img-wrap:after{
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: url("../../assets/img/property/news_banner_mask.png") no-repeat;
        background-size: cover;
    }

    .swiper-img-wrap img{
        width: 100%;
        max-height: unset;
        position: relative;
    }
</style>